import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Breadcrumbs as MUIBreadcrumbs } from '@mui/material';

export default function Breadcrumbs({ links, ...other }: any) {
  const listDefault = links.map((link: any) => (
    <LinkItem
      key={link.name}
      link={link}
    />
  ));

  return (
    <MUIBreadcrumbs
      separator={
        <Box
          component='span'
          sx={{
            width: 4,
            height: 4,
            borderRadius: '50%',
            bgcolor: 'text.disabled',
          }}
        />
      }
      {...other}
    >
      {listDefault}
    </MUIBreadcrumbs>
  );
}

function LinkItem({ link }: any) {
  const { href, name, icon } = link;
  return (
    <Link
      key={name}
      variant='body2'
      component={RouterLink}
      to={href || '#'}
      sx={{
        lineHeight: 2,
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'text.primary',
        '& > div': { display: 'inherit' },
      }}
    >
      {icon && (
        <Box sx={{ mr: 1, '& svg': { width: 20, height: 20 } }}>{icon}</Box>
      )}
      {name}
    </Link>
  );
}
